import {
  type ChanelActionType, type IncomingMessagePayload,
  PublickConnectionChannels, WebSocketConnectionManager
} from "../../index";
import { BestBidOfferRepository } from "@trading/core";
import type { BestBidOfferData, BestBidOfferModel } from "@trading/core/src/models/best-bid-and-offer.model";

export class BestBidOfferRepoWs implements BestBidOfferRepository {
  private wsChannel = PublickConnectionChannels['BEST_BID_OFFER']

  constructor(private wsManager: WebSocketConnectionManager) {
  }

  /**
   * Обработчик канала не зависит от состава подписки: тики по всем symbols
   * приходят одним потоком. Возвращает функцию снятия обработчика.
   */
  public async addUpdateHandler(
    actionName: ChanelActionType,
    cb: (data: BestBidOfferData) => void
  ): Promise<() => void> {
    const connection = await this.wsManager.getConnection('public')

    return connection.addChannelHandler(this.wsChannel, (data: IncomingMessagePayload<BestBidOfferModel>) => {
      if (data.type === actionName) {
        cb(data.data)
      }
    })
  }

  public async subscribeToSymbols(instruments: string[]): Promise<void> {
    if (!instruments.length) {
      return
    }

    const connection = await this.wsManager.getConnection('public')

    // функция отписки из subscribeToChannelMessages не нужна: состав подписки
    // снимается адресно через unsubscribeFromSymbols
    connection.subscribeToChannelMessages(this.wsChannel, {symbols: instruments})
  }

  public async unsubscribeFromSymbols(instruments: string[]): Promise<void> {
    if (!instruments.length) {
      return
    }

    const connection = await this.wsManager.getConnection('public')
    connection.unsubscribeToChannelMessages(this.wsChannel, {symbols: instruments})
  }
}
